module.exports = __webpack_public_path__ + "static/media/COSAssessmentsEveryDeploy3.5ccd02e4.png";